import { render, staticRenderFns } from "./LKA01.vue?vue&type=template&id=5564b418"
import script from "./LKA01.vue?vue&type=script&lang=js"
export * from "./LKA01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports